export const removePromoCode = ({ updateState }) => {
  updateState({
    promotions: {},
  });
};
